import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';

const PirateFortress = {
  id: "33",
  name: "Pirate Fortress",
  width: 5,
  height: 5,
  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Pirate_Fortress",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Pirate_Fortress',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asPerEraAndLevel({
        stoneAge: [
          15, 15, 24, 24, 33, 33, 40, 40, 47, 47, 53, 53, 53, 53, 63, 63, 68, 68,
          73, 73, 73, 73, 82, 82, 86, 86, 90, 90, 94, 94, 94, 100, 100, 104, 104,
          107, 107, 111, 113, 115, 117, 119, 121, 123, 125, 127, 129, 131, 133,
          135, 137, 139, 141, 143, 145, 147, 149, 151, 153, 155,
        ],
        bronzeAge: [
          20, 20, 43, 43, 59, 59, 72, 72, 84, 84, 95, 95, 95, 95, 114, 114, 123,
          123, 132, 132, 132, 132, 148, 148, 155, 155, 163, 163, 170, 170, 170,
          180, 180, 187, 187, 193, 193, 200, 203, 207, 210, 214, 217, 221, 224,
          228, 231, 235, 238, 242, 245, 249, 252, 256, 259, 263, 266, 270, 273,
          277,
        ],
        minoanEra: [
          30, 30, 63, 63, 85, 85, 104, 104, 121, 121, 137, 137, 137, 137, 165,
          165, 178, 178, 190, 190, 190, 190, 213, 213, 224, 224, 235, 235, 245,
          245, 245, 260, 260, 270, 270, 279, 279, 288, 292, 297, 301, 306, 310,
          315, 319, 324, 328, 333, 337, 342, 346, 351, 355, 360, 364, 369, 373,
          378, 382, 387,
        ],
        classicGreece: [
          40, 40, 82, 82, 112, 112, 137, 137, 159, 159, 179, 179, 179, 179, 216,
          216, 233, 233, 249, 249, 249, 249, 279, 279, 293, 293, 307, 307, 320,
          320, 320, 340, 340, 353, 353, 365, 365, 377, 383, 389, 395, 401, 407,
          413, 419, 425, 431, 437, 443, 449, 455, 461, 467, 473, 479, 485, 491,
          497, 503, 509,
        ],
        earlyRome: [
          50, 50, 101, 101, 138, 138, 169, 169, 196, 196, 221, 221, 221, 221, 267,
          267, 287, 287, 307, 307, 307, 307, 345, 345, 362, 362, 379, 379, 396,
          396, 396, 420, 420, 436, 436, 451, 451, 466, 473, 481, 488, 496, 503,
          511, 518, 526, 533, 541, 548, 556, 563, 571, 578, 586, 593, 601, 608,
          616, 623, 631,
        ],
        romanEmpire: [
          60, 60, 121, 121, 164, 164, 201, 201, 234, 234, 263, 263, 263, 263, 317,
          317, 342, 342, 366, 366, 366, 366, 410, 410, 431, 431, 452, 452, 471,
          471, 471, 500, 500, 519, 519, 537, 537, 554, 562, 571, 579, 588, 596,
          605, 613, 622, 630, 639, 647, 656, 664, 673, 681, 690, 698, 707, 715,
          724, 732, 741,
        ],
        byzantineEra: [
          70, 70, 140, 140, 190, 190, 233, 233, 271, 271, 306, 306, 306, 306, 368,
          368, 397, 397, 424, 424, 424, 424, 476, 476, 500, 500, 524, 524, 547,
          547, 547, 580, 580, 601, 601, 622, 622, 643, 653, 664, 674, 685, 695,
          706, 716, 727, 737, 748, 758, 769, 779, 790, 800, 811, 821, 832, 842,
          853, 863, 874,
        ],
        ageOfTheFranks: [
          80, 80, 159, 159, 217, 217, 265, 265, 308, 308, 348, 348, 348, 348, 419,
          419, 452, 452, 483, 483, 483, 483, 541, 541, 569, 569, 596, 596, 622,
          622, 622, 660, 660, 684, 684, 708, 708, 732, 744, 756, 768, 780, 792,
          804, 816, 828, 840, 852, 864, 876, 888, 900, 912, 924, 936, 948, 960,
          972, 984, 996,
        ],
        feudalAge: [
          90, 90, 178, 178, 242, 242, 296, 296, 344, 344, 388, 388, 388, 388, 467,
          467, 504, 504, 538, 538, 538, 538, 604, 604, 635, 635, 665, 665, 694,
          694, 694, 736, 736, 763, 763, 790, 790, 816, 829, 842, 855, 868, 881,
          894, 907, 920, 933, 946, 959, 972, 985, 998, 1011, 1024, 1037, 1050,
          1063, 1076, 1089, 1102,
        ],
        iberianEra: [
          99, 99, 196, 196, 266, 266, 326, 326, 378, 378, 427, 427, 427, 427, 514,
          514, 554, 554, 592, 592, 592, 592, 664, 664, 699, 699, 732, 732, 763,
          763, 763, 810, 810, 839, 839, 869, 869, 898, 893, 907, 921, 935, 949,
          963, 977, 991, 1005, 1019, 1033, 1047, 1061, 1075, 1089, 1103, 1117,
          1131, 1145, 1159, 1173, 1187,
        ],
        kingdomOfSicily: [
          109, 109, 216, 216, 293, 293, 359, 359, 416, 416, 470, 470, 470, 470,
          565, 565, 609, 609, 651, 651, 651, 651, 730, 730, 769, 769, 805, 805,
          839, 839, 839, 891, 891, 923, 923, 956, 956, 988, 1004, 1020, 1036,
          1052, 1068, 1084, 1100, 1116, 1132, 1148, 1164, 1180, 1196, 1212, 1228,
          1244, 1260, 1276, 1292, 1308, 1324, 1340,
        ],
        highMiddleAges: [
          120, 120, 238, 238, 322, 322, 395, 395, 458, 458, 517, 517, 517, 517,
          622, 622, 670, 670, 716, 716, 716, 716, 803, 803, 846, 846, 886, 886,
          923, 923, 923, 980, 980, 1015, 1015, 1052, 1052, 1087, 1112, 1130, 1148,
          1166, 1184, 1202, 1220, 1238, 1256, 1274, 1292, 1310, 1328, 1346, 1364,
          1382, 1400, 1418, 1436, 1454, 1472, 1490,
        ],
        earlyGothicEra: [
          122, 122, 244, 244, 332, 332, 409, 409, 476, 476, 539, 539, 539, 539,
          652, 652, 704, 704, 754, 754, 754, 754, 849, 849, 896, 896, 940, 940,
          981, 981, 981, 1044, 1044, 1083, 1083, 1124, 1124, 1163, 1181, 1200,
          1219, 1238, 1257, 1276, 1295, 1314, 1333, 1352, 1371, 1390, 1409, 1428,
          1447, 1466, 1485, 1504, 1523, 1542, 1561, 1580,
        ],
        lateGothicEra: [
          0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0
        ],
      }),
      CultureRange.asPerLevel([
        1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4,
        4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
        5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
      ]),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asCallbackWithLevel(
        (level) => {
          if (level <= 3) {
            return 0;
          }
          if (level <= 9) {
            return 1;
          }
          if (level <= 19) {
            return 2;
          }
          if (level <= 29) {
            return 3;
          }
          if (level <= 39) {
            return 4;
          }
          if (level <= 44) {
            return 5;
          }
          if (level <= 49) {
            return 6;
          }
          if (level <= 54) {
            return 7;
          }
          if (level <= 59) {
            return 8;
          }
          return 9;
        }
      ).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
    new PassiveAura(
      PassiveAuraType.ALL_BARRACKS_RECRUITMENT_TIME_BONUS,
      EffectAmount.asPerLevel([
        5, 6.8, 6.8, 6.8, 6.8, 6.8, 6.8, 13.7, 13.7, 13.7,
        13.7, 17, 17, 18.6, 18.6, 20, 20, 21.3, 21.3, 21.3,
        21.3, 23.9, 23.9, 25.1, 25.1, 26.2, 26.2, 27.3, 27.3, 27.3,
        29, 29, 30, 30, 31, 31, 32, 32, 33, 34,
        34.5, 35, 35.5, 36, 36.5, 37, 37.5, 38, 38.5, 39,
        39.5, 40, 40.5, 41, 41.5, 42, 42.5, 43, 43.5, 44
      ]),
      '%',
    ),
  ]),
};

export default PirateFortress;
